import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Plugin Modules
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { OrchestraHomeComponent } from './orchestra-home/orchestra-home.component';
import { OrchestraLoginComponent } from './orchestra-login/orchestra-login.component';
import { GoogleLoginComponent } from './google-login/google-login.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
//import { OrchestraAllMenuComponent } from './orchestra-all-menu/orchestra-all-menu.component'
// import { BrandLogoComponent } from './hope-ui/widgets/brand-logo/brand-logo.component';
// //import { BrandNameComponent } from './hope-ui/widgets/brand-name/brand-name.component';
// import { AuthEffectComponent } from './hope-ui/widgets/auth-effect/auth-effect.component';

const routes:Routes = [
  {

      path: '', component: OrchestraHomeComponent, children: [
        {
          path: 'viewer/:apps/:path', component: ImageViewerComponent
        }
      ],
  },
  {
    path: 'google-login',
    component: GoogleLoginComponent
  },
  {
    path: 'login', component: OrchestraLoginComponent,
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    NgbModule,
    CommonModule
  ],
  exports:[
    RouterModule,
//    BrandLogoComponent,
//    AuthEffectComponent,


  ],
  declarations: [
//    BrandLogoComponent,
//    AuthEffectComponent,
  ],
  providers: [
  ]
})
export class AppRoutingModule { }
